<template>
  <div v-if="drawComponent">
    <div v-if="showForm">
      <div class="col-sm-12">
        <form @submit.prevent="saveData()">
          <panel :title='hideHeader ? "" : (object.id ? "Apartment #" + object.data.code : "New apartment")' :footerShow="!hideHeader">
            <div class="row" v-if="!createMode && !editMode">
              <div class="pull-right">
                <a class="btn btn-warning" @click.prevent='enterEditMode' v-if="_can('updateApartment')">
                  <i class="icon-pencil"></i> <span class="text-semibold">Edit</span>
                </a>
              </div>
            </div>
            <div>
              <div class="col-sm-6">
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('code') }">
                      <label class="control-label">Code</label>
                      <input type="text" v-model="object.data.code" :readonly="!editMode && !createMode" class="form-control" @keyup.enter="submitData"/>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('floor') }">
                      <label class="control-label">Floor</label>
                      <input type="text" v-model="object.data.floor" :readonly="!editMode && !createMode" class="form-control" @keyup.enter="submitData"/>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('area') }">
                      <label class="control-label">Area (m<sup>2</sup>)</label>
                      <input type="number" v-model="object.data.area" :readonly="!editMode && !createMode" class="form-control" @keyup.enter="submitData"/>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('refurbishment') }">
                      <label class="control-label">Refurbishment</label>
                      <input type="text" v-model="object.data.refurbishment" :readonly="!editMode && !createMode" class="form-control" @keyup.enter="submitData"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('price') }">
                      <label class="control-label">Type</label>
                      <select v-model="object.type" :readonly="!editMode && !createMode" class="form-control">
                        <option value="apartment" :disabled="!editMode && !createMode">Apartment</option>
                        <option value="commercial" :disabled="!editMode && !createMode">Commercial space</option>
                        <option value="garage" :disabled="!editMode && !createMode">Garage</option>
                        <option value="storage" :disabled="!editMode && !createMode">Storage room</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('price') }">
                      <label class="control-label">Price &euro;</label>
                      <money v-model="object.data.price" ref="rent_price" :readonly="!editMode && !createMode" class="form-control" @enter-hit="submitData"></money>
                      <!-- input type="number" v-model="object.data.price" :readonly="!editMode && !createMode" class="form-control" @keyup.enter="submitData"/ -->
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('rent_month') }">
                      <label class="control-label">Rent / month &euro;</label>
                      <money v-model="object.data.rent_month" ref="rent_month" :readonly="!editMode && !createMode" class="form-control" @enter-hit="submitData" @change="monthlyChange"></money>
                      <!-- input type="number" v-model="object.data.rent_month" :readonly="!editMode && !createMode" class="form-control" @keyup.enter="submitData"/ -->
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('rent_year') }">
                      <label class="control-label">Rent / year &euro;</label>
                      <money v-model="object.data.rent_year" ref="rent_year" :readonly="!editMode && !createMode" class="form-control" @enter-hit="submitData" @change="yearlyChange"></money>
                      <!-- input type="number" v-model="object.data.rent_year" :readonly="!editMode && !createMode" class="form-control" @keyup.enter="submitData"/ -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div slot="footerElements" v-if="!hideHeader">
              <div class="pull-right">
                <router-link tag="button" :to="{name: 'apartment'}" class="btn btn-link legitRipple">Cancel</router-link>
                <button type="submit" @click.prevent="saveData()" :disabled="errors.any()" class="btn btn-primary legitRipple">Save changes</button>
              </div>
            </div>
          </panel>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ApartmentService from '@/services/apartment.service'
import ApartmentDataService from '@/services/apartmentData.service'
import Panel from '@/components/_partial/_atomic/panel'

export default {
  name: 'ApartmentForm',
  components: {Panel},

  props: ['entity', 'oid', 'project', 'hideHeader', 'createMode'],
  data () {
    return {
      id: null,
      object: {
        data: {}
      },
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: ApartmentService,
      services: {
        apartmentData: ApartmentDataService
      },
      statuses: [],
      systemStatuses: [],
      groupStatuses: [],
      showForm: false,
      editMode: false,
      mode: {
        statusMap: {},
        resetAfterMount: false
      },
      /** **/
      hasChanges: false,
      savingChanges: false,
      drawComponent: true
    }
  },

  computed: {},

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.groupStatuses = Vue.config.statusGroups['project'] ? Vue.config.statusGroups['project'] : Vue.config.statusGroups['*']
    this.statuses = []
    for (let i = 0; i < this.groupStatuses.length; i++) {
      this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
    }
  },

  watch: {
    '$route': 'flushObjectIfRequired',
    'entity': 'flushObjectIfRequired'
  },

  mounted () {
    this.reset(true)
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    flushObjectIfRequired () {
      if (this.$route.name === 'apartment.create' || this.createMode === true) {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          if (typeof this.service.__itemTemplate[i] === 'object') {
            if (i === 'data') {
              this.object[i] = Object.assign({}, this.services['apartmentData'].__itemTemplate)
            } else {
              this.object[i] = Object.assign({}, this.service.__itemTemplate[i])
            }
          } else {
            this.object[i] = this.service.__itemTemplate[i]
          }
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          this.service.item(this.oid, result => {
            for (let i in result) {
              if (result.hasOwnProperty(i)) {
                if (typeof result[i] === 'object') {
                  this.object[i] = Object.assign({}, result[i])
                } else {
                  this.object[i] = result[i]
                }
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
          })
        } else {
          if (this.entity) {
            for (let i in this.entity) {
              if (this.entity.hasOwnProperty(i)) {
                if (typeof this.entity[i] === 'object') {
                  this.object[i] = Object.assign({}, this.entity[i])
                } else {
                  this.object[i] = this.entity[i]
                }
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
          }
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            if (typeof this.entity[i] === 'object') {
              this.object[i] = Object.assign({}, this.entity[i])
            } else {
              this.object[i] = this.entity[i]
            }
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      this.makeIdFilter()
    },

    refresh (newInstance) {
      if (!this.object.id && this.oid) {
        this.service.item(this.oid, result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              if (typeof result[i] === 'object') {
                this.object[i] = Object.assign({}, result[i])
              } else {
                this.object[i] = result[i]
              }
            }
          }
          this.id = this.object.id
          this.$emit('loadObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        })
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              if (typeof newInstance[i] === 'object') {
                this.object[i] = Object.assign({}, newInstance[i])
              } else {
                this.object[i] = newInstance[i]
              }
            }
          }
          this.id = this.object.id
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      this.makeIdFilter()
    },

    enterEditMode () {
      this.editMode = true
      this.$emit('enterEditMode')
    },

    cancelEditMode () {
      this.editMode = false
      this.$emit('cancelEditMode')
    },

    setItemStatus (item, status) {
      this.service.update(item, {
        'id': item,
        'status': status
      }, result => {
        this.service.item(result.id, newdata => {
          this.refresh(newdata)
          this.hasChanges = true
          this.hasChanges = false
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    yearlyChange (evt) {
      console.log(evt, this.object.data.rent_year)
    },

    monthlyChange (evt) {
      this.object.data.rent_year = evt * 12
    },

    submitData () {
      if (this.hideHeader) {
        this.$emit('submitted', true)
      }
    },

    saveData () {
      let $vm = this
      if (this.id) {
        $vm.service.update($vm.id, $vm.prepareData($vm.object), resultObject => {
          if ($vm.object.data.hasOwnProperty('id')) {
            let $subvm = $vm
            $vm.services['apartmentData'].update($vm.object.id, $vm.object.data.id, $vm.prepareDataData($vm.object.data), resultObjectData => {
              $subvm.$emit('updated', $subvm.object)
            })
          } else {
            $vm.services['apartmentData'].create($vm.object.id, $vm.prepareDataData($vm.object.data), resultObjectData => {
              $vm.$emit('updated', $vm.object)
            })
          }
        })
      } else {
        $vm.service.create($vm.prepareData($vm.object), result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              if (typeof result[i] === 'object' && i === 'data') {
                // DON'T FLUSH DATA JUST TYPED IN FORM!!!
                // $vm.object[ i ] = Object.assign({}, result[i])
              } else {
                $vm.object[i] = result[i]
              }
            }
          }
          if (result.id) {
            $vm.object.id = result.id
          }
          $vm.object.data = Object.assign({apartment_id: $vm.object.id}, $vm.object.data)
          $vm.services['apartmentData'].create($vm.object.id, $vm.prepareDataData($vm.object.data), result => {
            if ($vm.hideHeader) {
              $vm.$emit('created', $vm.object)
            } else {
              $vm.$router.push('/project/details/' + parseInt($vm.object.id))
            }
          })
        })
      }
    },

    saveChanges () {
      if (this.hasChanges) {
        /* this.savingChanges = true
        this.object.purchaseOrderProducts.forEach(item => {
          promises.push(PoProductService.update(this.id, item.id, item))
        })
        Promise.all(promises).then(() => {
          this.savingChanges = false
          this.hasChanges = false
          this.reset()
        }) */
      }
    },

    prepareData (obj) {
      let template = {}
      if (obj.id) {
        template = {
          updated_by: this.$store.getters.userId,
          created_by: obj.created_by
        }
      } else {
        template = {created_by: this.$store.getters.userId}
      }
      if (typeof obj.created_by === 'object') {
        obj.created_by = this.$store.getters.userId
      }
      if (typeof obj.created_at === 'object') {
        obj.created_at = null
      }

      let result = Object.assign(template, obj)
      if (!result.project_id && this.project) {
        result.project_id = this.project.id
      }
      delete(result.projectStatus)
      return result
    },

    prepareDataData (obj) {
      let template = {}
      if (obj.id) {
        template = {
          updated_by: this.$store.getters.userId,
          created_by: obj.created_by
        }
      } else {
        template = {created_by: this.$store.getters.userId}
      }
      let result = Object.assign(template, obj)
      return result
    },

    canBeChanged () {
      let result = typeof this.object === 'object'
      if (result) {
        result = result && this.object.hasOwnProperty('id') && this.object.id
      }
      result = result && this.object.status === 1
      return result
    },

    /** **/

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
      if (this.object && Array.isArray(this.object.purchaseOrderProducts)) {
        for (let i in this.object.purchaseOrderProducts) {
          this.idFilter.push(this.object.purchaseOrderProducts[i].product_id)
        }
      }
    },

    __currencyCode (id) {
      for (let i in this.systemCurrencies) {
        if (this.systemCurrencies[i].id === id) {
          return this.systemCurrencies[i].code
        }
      }
      return ''
    }

    /** action methods **/

    /** sub-action methods **/

  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>

</style>
